<script setup lang="ts">
import PageLoader from '@/layers/base/components/PageLoader .vue'
const { isLoading } = usePageLoading()

</script>

<template>
  <div>
    <!-- <PageLoader v-if="isLoading" /> -->
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>